import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, inject, DOCUMENT } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, NgTemplateOutlet, RouterLink],
})
export class ButtonComponent {
    private document = inject(DOCUMENT);

    @Input() color = 'primary';
    @Input() url?: string | unknown[];
    @Input() replaceUrl = false;
    @Input() skipLocationChange = false;
    @Input() type = 'link';
    @Input() disabled = false;
    @Output() btnClick = new EventEmitter();

    get isUrlLink(): boolean {
        if (this.url && typeof this.url === 'string') {
            return this.url.includes('http');
        }

        return false;
    }

    get isCurrentUrl(): boolean {
        if (this.url && typeof this.url === 'string') {
            return this.url.includes(this.document.location.hostname);
        }

        return false;
    }

    onClick(): void {
        this.btnClick.emit();
    }
}
